"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceType = exports.SessionInitiator = void 0;
var SessionInitiator;
(function (SessionInitiator) {
    SessionInitiator["Login1Fa"] = "login1fa";
    SessionInitiator["Login2Fa"] = "login2fa";
    SessionInitiator["Registration"] = "registration";
    SessionInitiator["ChangePassword"] = "change_password";
    SessionInitiator["ResetPassword"] = "reset_password";
    SessionInitiator["VerifyPhone"] = "verify_phone";
    SessionInitiator["VerifyEmail"] = "verify_email";
    SessionInitiator["RegistrationCpfManual"] = "registration_cpf_manual";
    SessionInitiator["RegistrationCpfNumber"] = "registration_cpf_number";
})(SessionInitiator || (exports.SessionInitiator = SessionInitiator = {}));
var DeviceType;
(function (DeviceType) {
    DeviceType["Desktop"] = "desktop";
    DeviceType["Mobile"] = "mobile";
    DeviceType["Unknown"] = "unknown";
})(DeviceType || (exports.DeviceType = DeviceType = {}));
//# sourceMappingURL=session.js.map